import React from 'react'
import StandardModal from './StandardModal'


import { StyledFormModalContainer } from './styles'

const FormModal = ({
  isOpen,
  modalHandler,
  children
}) => {
  return (
    <StandardModal
      wrapperId='form-modal'
      lockBody={false}
      isOpen={isOpen}
      setIsOpen={modalHandler}
      hideCloseButton
      wrapperProps={{
        css: {
          position: 'fixed',
          top: 'unset',
          bottom: 0,
          height: 'auto',
        }
      }}
      containerProps={{
        css: {
          backgroundColor: '$success',
          with: '100%',
          display: 'block',
          transformOrigin: 'center left',
        },
        initial: { y: '100%', },
        animate: { y: '0%', },
        exit: { y: '100%', },
        transition: {
          type: 'spring', duration: 0.4
        },
      }}
    >
      <StyledFormModalContainer>
        {children}
      </StyledFormModalContainer>
    </StandardModal>
  )
}

export default FormModal
